export const TARGET_PREFIXES = ['pdcn.co/e/'];

export const sanitizeAudioUrl = (url: string): string => {
  return TARGET_PREFIXES.reduce((acc, curr): string => {
    return acc.replace(curr, '');
  }, url);
};
